
import confetti from 'canvas-confetti'

/** Celebratory burst used after a successful vote. */
export function celebrate() {
  if (
    typeof window !== 'undefined' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ) {
    return
  }

  const colors = ['#a78bfa', '#38bdf8', '#2dd4bf', '#fb7185', '#fbbf24']
  const end = Date.now() + 900

  ;(function frame() {
    confetti({
      particleCount: 4,
      angle: 60,
      spread: 60,
      origin: { x: 0 },
      colors,
    })
    confetti({
      particleCount: 4,
      angle: 120,
      spread: 60,
      origin: { x: 1 },
      colors,
    })
    if (Date.now() < end) requestAnimationFrame(frame)
  })()

  confetti({
    particleCount: 120,
    spread: 90,
    startVelocity: 40,
    origin: { y: 0.6 },
    colors,
  })
}

